import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountEventsResponseDto } from 'src/app/core/classes/account-events-response-dto';
import { PatientList, PatientListRequestDto } from 'src/app/core/classes/patient-list';
import { PatientRequest } from 'src/app/core/classes/patient-request';
import { environment } from 'src/environments/environment';
import { EndPoints } from 'src/app/shared/EndPoints';
import { HttpService } from 'src/app/core/services/http/http.service';
import { BulkOrderUploadAuditLog, BulkOrderUploadResultWrapper } from 'src/app/core/classes/bulk-order-upload';
import { BulkOrderHistoryRequest } from 'src/app/core/classes/bulk-order-history-request';

@Injectable({
  providedIn: 'root'
})
export class BulkUploadService {

  private MyLabPortBaseUrl: string;
  constructor(
    private httpService: HttpService, private httpClient: HttpClient) {
    this.MyLabPortBaseUrl = environment.customerPortalServiceUrl;
  }

  public getPatientDetails(request: PatientListRequestDto, userId: string): Observable<PatientList[]> {
    return this.httpService.Post(this.MyLabPortBaseUrl +
      EndPoints.getPatientDetails + '/' + userId, request);
  }

  public getActiveEventsByAccount(request): Observable<AccountEventsResponseDto[]> {
    return this.httpService.Get(this.MyLabPortBaseUrl + EndPoints.getActiveEventsByAccount + request);
  }

  public downloadTemplate() {
    return this.httpService.Post(this.MyLabPortBaseUrl + EndPoints.BULK_UPLOAD_TEMPLATE_DOWNLOAD, null);
  }

  public validatePatientFileUpload(file: string | Blob, accountCode: string): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    return this.httpClient.post<any>(this.MyLabPortBaseUrl +
      EndPoints.BULK_UPLOAD_VALIDATE_PATIENT_INFO
        .concat(`${accountCode}`), formData);
  }


  public getPatientMyName(patientDeatails: PatientRequest): Observable<any[]> {
    return this.httpService.Post(this.MyLabPortBaseUrl +
      EndPoints.getBulkPatientDetails, patientDeatails);
  }

  public validateBulkOrderUpload(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    return this.httpClient.post<any>(environment.customerPortalServiceUrl +
      EndPoints.validateBulkOrderUpload, formData);
  }

  public async confirmBulkOrderUpload(wrapperRequest : BulkOrderUploadResultWrapper) {
    return await this.httpService.AsyncPost(environment.customerPortalServiceUrl +
      EndPoints.confirmBulkOrderUpload, wrapperRequest);
  }

  public  getBulkOrderAuditLog(request: BulkOrderHistoryRequest): Observable<BulkOrderUploadAuditLog[]> {
    return this.httpService.Post(this.MyLabPortBaseUrl + EndPoints.GetBulkOrderAuditLog , request);
  }

}
